import './style.scss';
import findIndex from 'lodash/findIndex';
import BookingIcon from '../../../../../../../../../Shared/BookingIcon';
import SeverityIcon from '../../../../../../../../../Shared/SeverityIcon';
import { Severity, severityCompareFunction, type INote } from '../../../../../../../../../../models/note.model';
import { IdHelper } from '../../../../../../../../../../helpers/id.helper';
import { NoteHelper } from '../../../../../../../../../../helpers/note.helper';
import { AnalyticsService } from '../../../../../../../../../../services/analytics-service';

function getDistinctAndOrderedNotes(notes: INote[]): INote[] {
  return notes?.filter((n1, index, array) => findIndex(array, (n2) => n2.text === n1.text) === index).sort((a, b) => severityCompareFunction(a.severity, b.severity)) ?? [];
}

function Notes({ notes, className }: { notes: INote[]; className?: string }) {
  return (
    <div className={`notes ${className ?? ''}`}>
      <ul className="list-unstyled">
        {getDistinctAndOrderedNotes(notes).map((note) => {
          const noteHeadingAndText = NoteHelper.getNoteHeadingAndText(note);
          const id = IdHelper.newUniqueId('note-collapsible-');
          return (
            <li key={note.text} className={`notes__note px-3 rounded text-break ${note.severity === Severity.low ? 'bg-blue' : 'bg-yellow'}`}>
              {noteHeadingAndText.heading && noteHeadingAndText.text && (
                <>
                  <div className="d-flex align-items-center">
                    {note.type === 'booking' ? <BookingIcon className="me-2" /> : <SeverityIcon severity={note.severity} className="me-2" />}
                    <button
                      type="button"
                      className="btn btn-link border-0 notes__collapse-button text-start flex-grow-1 text-decoration-none fw-bold py-3 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target={`#${id}`}
                      aria-expanded="false"
                      onClick={() => AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Visa meddelanden-detaljer', '')}
                    >
                      {noteHeadingAndText.heading}
                    </button>
                  </div>
                  <div id={id} className="collapse">
                    <div className="pb-3 d-block">{noteHeadingAndText.text}</div>
                  </div>
                </>
              )}
              {!noteHeadingAndText.heading && noteHeadingAndText.text && (
                <div className="d-flex align-items-center py-3">
                  {note.type === 'booking' ? <BookingIcon className="me-2" /> : <SeverityIcon severity={note.severity} className="me-2" />}
                  {noteHeadingAndText.text}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Notes;
